import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DateAdapter } from '../../shared/adapters/date-adapter';
import { Pagination } from '../../shared/models/pagination.model';
import { withDateAdapter, withDateAdapterPage } from '../../shared/rxjs/with-date-adapter';
import { environment as env } from './../../../environments/environment';
import { MedicalHistory } from './../../shared/models/medical-history';

@Injectable({
  providedIn: 'root'
})
export class MedicalHistoryService {
  private readonly endpoint = `${env.baseAPIUrl}/medical-history`;

  private readonly dateFields = ['date', 'createdAt', 'updatedAt', 'deletedAt'];
  private readonly transformDate = withDateAdapter<MedicalHistory>(this.dateFields);
  private readonly transformDatePage = withDateAdapterPage<Pagination<MedicalHistory>>(this.dateFields);

  constructor(private readonly http: HttpClient) { }

  getMedicalHistoryById(medicalHistoryId: string): Observable<MedicalHistory> {
    return this.http.get<MedicalHistory>(`${this.endpoint}/${medicalHistoryId}`)
      .pipe(this.transformDate);
  }

  paginateMedicalHistoryByPetId(petId: string, page: number = 0, pageSize: number = 10): Observable<Pagination<MedicalHistory>> {
    return this.http.get<Pagination<MedicalHistory>>(`${this.endpoint}/pet/${petId}?page=${page}&pageSize=${pageSize}`)
      .pipe(this.transformDatePage);
  }

  createMedicalHistory(medicalHistory: MedicalHistory): Observable<MedicalHistory> {
    return this.http.post<MedicalHistory>(`${this.endpoint}`, DateAdapter.toAPI(medicalHistory, this.dateFields))
      .pipe(this.transformDate);
  }

  updateMedicalHistory(medicalHistory: MedicalHistory): Observable<MedicalHistory> {
    return this.http.patch<MedicalHistory>(`${this.endpoint}/${medicalHistory.id}`, DateAdapter.toAPI(medicalHistory, this.dateFields))
      .pipe(this.transformDate);
  }

  deleteMedicalHistory(medicalHistoryId: string): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/${medicalHistoryId}`)
  }
}
